import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=2c0d290a&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&id=2c0d290a&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0d290a')) {
      api.createRecord('2c0d290a', component.options)
    } else {
      api.reload('2c0d290a', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=2c0d290a&", function () {
      api.rerender('2c0d290a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/notification.vue
// module id = Kxxe
// module chunks = 0